import React from 'react'
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const Placeshistory = () => {
    const parks = [
        {
            "NAME": "Golden Spike National Historic Site",
            "LAND ADMINISTRATOR": "National Park Service",
            "Address": "6200 N 22300 W, Corinne, UT 84307, United States",
            "Phone No:": "435-471-2209",
            "Website": "https://www.nps.gov/gosp/index.htm",
            "Established on": "May 10, 1869"
        },

    ]
    return (
        <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
            {/* Landing Section */}
            <LandingSection
                data={{ imageName: "history.webp", title: "National Historic Site" }}
            />

            {/* Main Content */}
            <div className=" mx-auto  py-12 w-full">
                {/* Intro Section */}
                <div className="text-center mb-12">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
                        Utah's National Historic Site
                    </h1>
                    <p className="text-xl text-blue-700">
                        Discover the stories behind Utah’s preserved historic treasures
                    </p>
                </div>

                {/* Parks Table */}
                <div className='flex items-center justify-center'>
                    <div className="bg-white rounded-xl  shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
                        <div className="overflow-x-auto">
                            <table className="min-w-full">
                                <thead className="bg-gradient-to-r from-blue-50 to-blue-100">
                                    <tr>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Name
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Land Administrator
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Contact
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Website
                                        </th>
                                        <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider">
                                            Established
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {parks.map((park, index) => (
                                        <tr key={index} className="hover:bg-blue-50 transition-colors">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park.NAME}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["LAND ADMINISTRATOR"]}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-center font-bold text-blue-900">{park["Phone No:"]}</div>
                                                <div className="text-sm text-center font-bold text-blue-900">{park.Address}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-center">
                                                <a
                                                    href={park.Website}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-blue-600 font-bold hover:text-blue-800 hover:underline"
                                                >
                                                    Visit Website
                                                </a>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-center font-bold text-blue-900">
                                                {park["Established on"]}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}

export default Placeshistory
